<script>
import { success_message } from "../../Helper/helper";
import { required } from "vuelidate/lib/validators";
import { faqService, faqCategoryService} from "../../services";

/**
 * FAQ component
 */
export default {
  data() {
    return {
      items: [],
      typeform: {
        question: "",
        answer: "",
        type: "0",
        question_another_lang: "",
        answer_another_lang: "",
        status: "1",
        faq_id: "",
      },
    };
  },
  validations: {
    typeform: {
      question: {
        required,
      },
      question_another_lang: {
        required
      },
      answer: {
        required,
      },
      answer_another_lang: {
        required
      },
      faq_id: {
        required,
      },
    },
  },
  mounted() {
    this.getAllFaqCategory();
  },
  methods: {
    getAllFaqCategory() {
      faqCategoryService.getAllFaqCategory()
      .then((response) => {
        this.items = response.data.result;
      });
    },
    FaqInIt() {
      this.$v.$touch();

      if (this.$v.typeform.$invalid) {
        return;
      } else {
        const fd = new FormData();
        fd.append("question", this.typeform.question);
        fd.append("answer", this.typeform.answer);
        fd.append("question_another_lang", this.typeform.question_another_lang);
        fd.append("answer_another_lang", this.typeform.answer_another_lang);
        fd.append("type", this.typeform.type);
        fd.append("status", this.typeform.status);
        fd.append("faq_id", this.typeform.faq_id);
        faqService.addFaq(fd).then((response) => {
          if (response.data.code === 200) {
            success_message(response.data.message);
            //this.$router.push({ name: "faq-list" });
          } else {
            error_message(response.data.message);
          }
        });
      }
    },
  },
};
</script>

<template>
  <b-form @submit.prevent="FaqInIt">
    <!-- FAQ Info Start -->
    <div class="card">
      <div class="card-body">
        <h4 class="card-title">{{ trans.get("__JSON__.FAQ Info") }}</h4>
        <p class="card-title-desc"></p>
        <div class="row">
          <div class="col-sm-6" v-if="$auth.setting">
            <b-form-group id="input-group-1">
              <label class="control-label required" for="question">{{trans.trans('__JSON__.Question Primary language', {lang: $auth.langauges[0].name})}}</label>
              <b-form-input
                id="question"
                name="question"
                v-model="$v.typeform.question.$model"
                type="text"
                :placeholder="
                  trans.trans('__JSON__.Question Primary language', {
                    lang: $auth.langauges[0].name,
                  })
                "
                :class="{ 'is-invalid': $v.typeform.question.$error }"
              ></b-form-input>
              <div v-if="$v.typeform.question.$error" class="invalid-feedback">
                <span v-if="!$v.typeform.question.required"
                  >{{ trans.get("__JSON__.Please enter Question", {lang: $auth.langauges[0].name}) }}.</span
                >
              </div>
            </b-form-group>
          </div>

          <div class="col-sm-6" v-if="$auth.langauges[1].name != 'No Secondary Language'">
            <label class="control-label required" for="question_another_lang">{{trans.trans('__JSON__.Question Secondary Language', {lang: $auth.langauges[1].name})}}</label>
            <b-form-group id="input-group-1">
              <b-form-input
                id="question_another_lang"
                name="question_another_lang"
                v-model="$v.typeform.question_another_lang.$model"
                type="text"
                :placeholder="
                  trans.trans('__JSON__.Question Secondary Language', {
                    lang: $auth.langauges[1].name,
                  })
                "
                :class="{ 'is-invalid': $v.typeform.question_another_lang.$error }"
              >
              </b-form-input>
              <div v-if="$v.typeform.question_another_lang.$error" class="invalid-feedback">
                <span v-if="!$v.typeform.question_another_lang.required"
                  >{{ trans.get("__JSON__.Please enter Question", {lang: $auth.langauges[1].name}) }}.</span
                >
              </div>
            </b-form-group>
          </div>

          <div class="col-sm-6">
            <b-form-group id="input-group-1" >
            <label class="control-label required" for="answer">{{trans.trans('__JSON__.Answer Primary Language', {lang: $auth.langauges[0].name})}}</label>
              <b-form-textarea
                rows="5"
                id="answer"
                v-model="$v.typeform.answer.$model"
                type="text"
                class="form-control"
                :placeholder="
                  trans.trans('__JSON__.Answer Primary Language', {
                    lang: $auth.langauges[0].name,
                  })
                "
                name="answer"
                :class="{ 'is-invalid': $v.typeform.answer.$error }"
              ></b-form-textarea>
              <div v-if="$v.typeform.answer.$error" class="invalid-feedback">
                <span v-if="!$v.typeform.answer.required"
                  >{{ trans.get("__JSON__.Please enter Answer", {lang: $auth.langauges[0].name}) }}.</span
                >
              </div>
            </b-form-group>
          </div>

          <div class="col-sm-6" v-if="$auth.langauges[1].name != 'No Secondary Language'">
             <label class="control-label required" for="answer_another_lang">{{trans.trans('__JSON__.Answer Secondary Language', {lang: $auth.langauges[1].name})}}</label>
            <b-form-group id="input-group-1">
              <b-form-textarea
                rows="5"
                id="answer_another_lang"
                v-model="$v.typeform.answer_another_lang.$model"
                type="text"
                class="form-control"
                :placeholder="
                  trans.trans('__JSON__.Answer Secondary Language', {
                    lang: $auth.langauges[1].name,
                  })
                "
                name="answer_another_lang"
                :class="{ 'is-invalid': $v.typeform.answer_another_lang.$error }"
              >
              </b-form-textarea>
              <div v-if="$v.typeform.answer_another_lang.$error" class="invalid-feedback">
                <span v-if="!$v.typeform.answer_another_lang.required"
                  >{{ trans.get("__JSON__.Please enter Answer", {lang: $auth.langauges[1].name}) }}.</span
                >
              </div>
            </b-form-group>
          </div>

          <div class="col-sm-6">
            <div class="form-group">
              <label class="control-label required">{{ trans.get("__JSON__.Type")}}</label>
                <select class="custom-select" v-model="$v.typeform.faq_id.$model" id="faq_id" name="faq_id" :class="{ 'is-invalid':$v.typeform.faq_id.$error }">
                  <option value="">{{trans.get('__JSON__.Select Category')}}</option>
                  <option v-for="cat in items" :value="cat.id" :key="cat.id">{{cat.name}}</option>
                </select>
              <div v-if="$v.typeform.faq_id.$error" class="invalid-feedback">
                <span v-if="!$v.typeform.faq_id.required">{{ trans.get('__JSON__.Please select faq category') }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-6">
            <button class="btn btn-primary mr-1 mt-3">
              {{ trans.get("__JSON__.ADD FAQ") }}
            </button>
            <b-button
              @click="$router.go(-1)"
              type="button"
              variant="secondary"
              class="mt-3"
              >{{ trans.get("__JSON__.Cancel") }}</b-button
            >
          </div>
        </div>
      </div>
    </div>
    <!-- FAQ Info End -->
  </b-form>
  <!-- end row -->
</template>
